
import { TranslationService } from "@/core/services/TranslationService";
import LineChart from "@/components/line-chart/LineChart.vue";
import VZModal from "@/components/content/VZModal.vue";
import { defineComponent, PropType, ref } from "vue";
type DateRangeEmitter = {
  VZDateRange: string[];
};
import { IForm } from "@/interfaces/iForm";
interface IDateFilterValue {
  startDate: "";
  endDate: "";
}

export default defineComponent({
  name: "line-chart-modal",
  emits: ["close-chart"],
  components: { VZModal, LineChart },
  props: {
    // value: { type: Boolean, default: false },
    viewName: { type: String, default: "" },
    reference: { type: String, default: "" },
    data: { type: Object as PropType<IForm>, required: true },
    dateFilterValue: {
      type: Object as PropType<IDateFilterValue>,
      required: true,
    },
    title: { type: String, default: "" },
    showDialog: { type: Boolean, default: false },
    userSiteId: { type: [String, Number], default: "" },
  },
  setup(props, { emit }) {
    const column = ref(true);
    const close = () => {
      emit("close-chart");
    };
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    return {
      t,
      close,
      column,
    };
  },
});
